module.exports = __webpack_public_path__ + "static/media/shaff1102.7a2cf25f.jpg";